<template>
  <div>
    <div v-if="files" class="attachments-container">
      <div v-for="(item,index) in files" :key="index">
        
          <img v-if="isImage(item)" :src="getSrc(item)" class="image-attachment"/>
          
          <video v-else-if="isVideo(item)" :src="getSrc(item)" class="image-attachment" autoplay controls="controls" muted="muted" />
        
          <audio v-else-if="isAudio(item)" controls :src="getSrc(item)" />

          <a v-else target="_blank" :href="getSrc(item)" class="link-attachment">
            <i class="fa fa-file"></i>
            <span v-html="getNameFile(item)"></span>
          </a>
      
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    props: {
      files: Array
    },
    name: 'attachments',
    data () {
      return {
        arr: []
      }
    },

    methods: {
      isImage (e) {
        let arr = e.split('|');
        if (arr[0] === 'image') {
          return true;
        } else return false;
      },

      isVideo (e) {
        let arr = e.split('|');
        if (arr[0] === 'video') {
          return true;
        } else return false;
      },

      isAudio (e) {
        let arr = e.split('|');
        if (arr[0] === 'audio') {
          return true;
        } else return false;
      },

      getSrc (e) {
        return 'https://' + this.$store.state.configuration.ip + '/attachments/' + e.split('|')[1];
      },

      //application/pdf|20200227/7651b1eb-7a59-4e1b-8b71-8733682ff44e.adjuntoconcaptura.pdf
      getNameFile (e) {
        if(e.indexOf('>') > -1){
          let index = e.indexOf('>');
          return e.substr(index + 1, e.length);
        }else{
          let arr = e.split('/');
          let name = arr[arr.length-1];
          return name.substr(36, name.length);
        }
      }
    }
  }
</script>

<style scoped>

@media screen and (max-width: 768px) {
  audio{
     width:calc(100% - 20px) !important;
  }
}

@media screen and (max-width: 372px) {
  audio{
     width:calc(100% - 50px) !important;
  }
}
  

  .attachments-container {
    min-width: 250px;
  }

  .link-attachment {
    color: white !important;
  }

  .self .link-attachment {
    color: #777 !important;
  }

  .image-attachment {
    max-width: 90%;
    width:100%;
    border-radius: 6px;
  }

</style>




// WEBPACK FOOTER //
// attachments.vue?0a3c93a8